import DraggableContainer from '@/shared/Activities/GameActivity/ClassicGameActivity/DragAndMatchActivity/DragAndMatchGame/GameLoop/DraggableContainer/DraggableContainer';
import { StyledFillGapsPage } from './FillGapsPage.styled';
import DraggableGapOption from './DraggableGapOption';
import useFillGapsPage from './useFillGapsPage.hook';
import DroppableGap from './DroppableGap';
import { DragOverlay } from '@dnd-kit/core';
import DraggableContent from '../../components/DraggableContent/DraggableContent';
import AudioPlayPauseButton from '../../components/AudioPlayPauseButton/AudioPlayPauseButton';
import AnswerFeedback from '../../components/AnswerFeedback/AnswerFeedback';

export default function FillGapsPage({ page, activityActions, folder }) {
  const { state, actions } = useFillGapsPage({ page, activityActions });

  const audioSrc = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${folder}/audios/${page.id}.mp3`;

  const options = state.options.filter(
    (option) => !state.answers.find((answer) => answer.id == option.id)
  );

  return (
    <StyledFillGapsPage>
      <div className="text">{page.data.text}</div>
      <DraggableContainer
        onDragStart={actions.onDragStart}
        onDragEnd={actions.onDragEnd}
      >
        <div className="lines">
          {state.lines.map((line, index) => (
            <div key={index} className="text-with-gaps">
              {line.parts.map((part, index) => {
                if (part.isGap) {
                  const answer = state.answers.find(
                    (answer) => answer.answerId == part.id
                  );
                  const option = answer
                    ? state.options.find((option) => option.id == answer.id)
                    : null;

                  const correctOption = state.options.find(
                    (option) => option.id == part.id
                  );
                  const isAnswerCorrect = answer?.id == correctOption.id;

                  return (
                    <DroppableGap key={index} id={part.id}>
                      <div className="gap">
                        {answer ? (
                          <DraggableGapOption
                            id={answer.id}
                            text={option.text}
                            audioFile={`${page.id}-${option.id}.mp3`}
                            disabled={state.answered}
                          >
                            <DraggableContent
                              id={option.id}
                              className="dropped"
                              style={{
                                visibility:
                                  option.id == state.draggedOptionId
                                    ? 'hidden'
                                    : 'visible',
                              }}
                            >
                              <span
                                className={`${
                                  state.answered && !isAnswerCorrect
                                    ? 'incorrect-answer'
                                    : ''
                                }`}
                              >
                                {option.text}
                              </span>
                              {state.answered && !isAnswerCorrect && (
                                <span className="correct-answer">
                                  {correctOption.text}
                                </span>
                              )}
                              <AnswerFeedback
                                className="feedback"
                                allAnswered={state.answered}
                                allCorrect={state.correct}
                                correct={option.id == part.id}
                              />
                            </DraggableContent>
                          </DraggableGapOption>
                        ) : null}
                      </div>
                    </DroppableGap>
                  );
                } else {
                  return part.text
                    .split(' ')
                    .map((word, wordIdx) => (
                      <span key={`${index}-${wordIdx}`}>{word}</span>
                    ));
                }
              })}
            </div>
          ))}
        </div>
        {state.answered && (
          <AudioPlayPauseButton
            size="large"
            src={audioSrc}
            className="audio-player mt"
          />
        )}
        <div className="options">
          {options.map((option) => {
            const audioSrc = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${folder}/audios/${page.id}-${option.id}.mp3`;
            // sound on drag
            return (
              <DraggableGapOption
                key={option.id}
                id={option.id}
                text={option.text}
                audioFile={`${page.id}-${option.id}.mp3`}
                disabled={state.answered}
              >
                <DraggableContent
                  style={{
                    visibility:
                      option.id == state.draggedOptionId ? 'hidden' : 'visible',
                  }}
                  id={option.id}
                >
                  {option.text}
                  <AudioPlayPauseButton
                    noGUI
                    src={audioSrc}
                    doPlay={state.doPlayOption == option.id}
                    onEnded={() => actions.onOptionPlayed()}
                  />
                </DraggableContent>
              </DraggableGapOption>
            );
          })}
        </div>
        <DragOverlay>
          {state.draggedOptionId ? (
            <DraggableContent className="dragged" id={state.draggedOptionId}>
              {
                state.options.find(
                  (option) => option.id == state.draggedOptionId
                ).text
              }
            </DraggableContent>
          ) : null}
        </DragOverlay>
      </DraggableContainer>
    </StyledFillGapsPage>
  );
}
